(() => {
  window.swinger.eventHub.register('click keyup', '.swinger-richtext[aria-expanded], .swinger-richtext[aria-expanded] *', (e) => {
    if (e.type !== 'click' && e.key !== 'Enter') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('.swinger-richtext');

    elem.setAttribute('aria-expanded', elem.ariaExpanded === 'true' ? 'false' : 'true');
  });
})();
